import angular from 'angular';
import tabularLoanList from './tabularLoanList';

export default angular
  .module('contactLendingTab.scenes.tabularLoanList', [])
  .component('tabularLoanList', tabularLoanList).name;
